!(function () {
  ("use strict");
  const t = "popup-component",
    i = "[data-popup-close]",
    o = "[data-notification-form]",
    e = "[data-product-notification-heading]",
    a = "[data-notification-submit]",
    s = "has-success",
    n = "hidden";
  customElements.get("product-notification") ||
    customElements.define(
      "product-notification",
      class extends HTMLElement {
        constructor() {
          console.log("constructor");
          super(),
            (this.notificationForm = this.querySelector(o)),
            (this.submitButton = this.querySelector(a)),
            (this.preventSubmit = !0),
            (this.popup = this.closest("dialog")),
            (this.popupClose = this.popup.querySelector(i));
        }
        connectedCallback() {
          console.log("connectedCallback", this.submitButton);
          this.checkState(),
            this.submitButton.addEventListener("click", (t) => {
              this.notificationSubmitEvent(t);
            }),
            this.popupClose.addEventListener("click", () => {
              this.removeStorage();
            });
        }
        checkState() {
          // Check for success state from sessionStorage (per-variant)
          const variantId =
            this.notificationForm.querySelector("[data-variant-id]")?.value;
          const successKey = `notification_success_${variantId}`;
          const wasSubmitted = window.sessionStorage.getItem(successKey);
          if (wasSubmitted) {
            this.showSuccessState();
            window.sessionStorage.removeItem(successKey);
          }
        }
        async notificationSubmitEvent(t) {
          if (!this.preventSubmit) return;

          t.preventDefault();
          this.removeStorage();
          this.writeStorage();

          // Get form data
          const emailInput = this.notificationForm.querySelector(
            'input[type="email"]'
          );
          const productInput = this.notificationForm.querySelector(
            "[data-notification-product]"
          );

          if (!emailInput || !emailInput.value) {
            this.showError("Please enter a valid email address.");
            return;
          }

          const email = emailInput.value.trim();
          const product = productInput ? productInput.value : "";

          // Show loading state
          const originalButtonText = this.submitButton
            ? this.submitButton.innerHTML
            : "";
          if (this.submitButton) {
            this.submitButton.disabled = true;
            this.submitButton.innerHTML = "<span>Subscribing...</span>";
          }

          try {
            // Subscribe to Klaviyo list
            if (!window._learnq) {
              this.showError(
                "Email service is not available. Please try again later."
              );
              if (this.submitButton) {
                this.submitButton.disabled = false;
                this.submitButton.innerHTML = originalButtonText;
              }
              return;
            }

            // Get Klaviyo public API key
            const klaviyoPublicKey =
              document.body.getAttribute("data-klaviyo-key");

            if (!klaviyoPublicKey) {
              this.showError("Email service is not configured.");
              if (this.submitButton) {
                this.submitButton.disabled = false;
                this.submitButton.innerHTML = originalButtonText;
              }
              return;
            }

            // Get variant ID from the form data
            const variantId =
              this.notificationForm.querySelector("[data-variant-id]")?.value;

            if (!variantId) {
              this.showError("Product information is missing.");
              if (this.submitButton) {
                this.submitButton.disabled = false;
                this.submitButton.innerHTML = originalButtonText;
              }
              return;
            }

            // Call Klaviyo's Back in Stock API endpoint
            const payload = {
              data: {
                type: "back-in-stock-subscription",
                attributes: {
                  profile: {
                    data: {
                      type: "profile",
                      attributes: {
                        email: email,
                      },
                    },
                  },
                  channels: ["EMAIL"],
                },
                relationships: {
                  variant: {
                    data: {
                      type: "catalog-variant",
                      id: `$shopify:::$default:::${variantId}`,
                    },
                  },
                },
              },
            };
            console.log("back in stock payload", payload);

            const response = await fetch(
              `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${klaviyoPublicKey}`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  revision: "2024-06-15",
                },
                body: JSON.stringify(payload),
              }
            );

            if (!response.ok) {
              throw new Error(
                "Failed to subscribe to back in stock notifications"
              );
            }

            // Success - store success state (per-variant) and show UI
            const successKey = `notification_success_${variantId}`;
            window.sessionStorage.setItem(successKey, "true");
            this.showSuccessState();
          } catch (error) {
            // Network or other error
            this.showError("Unable to subscribe. Please try again.");
            if (this.submitButton) {
              this.submitButton.disabled = false;
              this.submitButton.innerHTML = originalButtonText;
            }
          }
        }
        showSuccessState() {
          // Hide the form heading
          const heading = this.querySelector(e);
          if (heading) heading.classList.add(n);

          // Add success class to popup component
          const popupComponent = this.closest(t);
          if (popupComponent) popupComponent.classList.add(s);

          // Show the dialog
          if (this.popup) {
            this.popup.removeAttribute("inert");
            if (typeof this.popup.showModal === "function") {
              this.popup.showModal();
            } else {
              this.popup.setAttribute("open", "");
            }
          }
        }
        showError(message) {
          // Create or update error message display
          let errorContainer = this.querySelector(
            ".product__notification__error"
          );
          if (!errorContainer) {
            errorContainer = document.createElement("div");
            errorContainer.className = "product__notification__error";
            this.notificationForm.appendChild(errorContainer);
          }
          errorContainer.innerHTML = `<p style="color: #d63638; margin-top: 1em;">${message}</p>`;
        }
        writeStorage() {
          void 0 !== window.sessionStorage &&
            window.sessionStorage.setItem(
              "notification_form_id",
              this.notificationForm.id
            );
        }
        removeStorage() {
          window.sessionStorage.removeItem("notification_form_id");
        }
      }
    );
})();
